export default {
  setPromoCodes: (state, promoCodes) => (state.promoCodes = promoCodes),
  setLoading: (state, loading) => (state.loading = loading),
};
